<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/TI3s1v/tc-custom/9781429909587.jpg?1747063511710" alt="This image is the cover for the book Bad Faith, Sister Agatha Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Bad Faith, Sister Agatha Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A New Mexico nun must pray she can find a killer after murder disrupts a mass in this cozy mystery series debut by the authors of the Ella Clah novels.</b></p><p><b>“The Thurlos write with the same grace, savvy, and sense of place that make the Ella Clah mysteries so absorbing. Sister Agatha deserves a place with Father Brown in the gallery of canny religious sleuths.” —<i>Booklist </i>(starred review)</b></p><p>Once she was Professor Mary Naughton, investigative reporter, teacher, and free spirit. Now she is Sister Agatha of Our Lady of Hope, a cloistered, financially struggling monastery in New Mexico. As an extern—a nun who handles her order’s dealings with the outside world—she is used to having her faith and newly acquired patience tested. But when popular chaplain Father Anselm is poisoned to death in the middle of mass, Sister Agatha must bring all her worldly skepticism and savvy instincts to uncover the truth before scandal and unjust suspicion destroy Our Lady of Hope’s future. She’s up against a hostile local sheriff, an ex-lover who’s never forgiven her for “abandoning” their life together. She’s got no shortage of suspects-with-secrets outside—and inside—the monastery. And she’ll need to race the clock to stop one remorseless murderer before there’s more hell to pay . . .</p><p><b>“[A] beguiling new series opener. . . . Lay Catholics curious about convent life will find the details ring true, while even non-Catholics will find themselves caught up in the orderly round of work and prayer.” —<i>Publishers Weekly</i></b></p><p><b>“One of the most original and interesting characters in the mystery field today . . . I look forward to [her] next adventure with much anticipation. Until then, I'll have to comfort myself with thinking holy thoughts.” —Carolina Garcia-Aguilera, Shamus Award–winning author of <i>Bitter Sugar</i></b></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Aimée Thurlo, David Thurlo
      </h2>
      
      <p class="authorDescription body article"><B>Aimée and David Thurlo</B> are the authors of more than forty novels, including seven mysteries featuring Ella Clah, and have been published in more than twenty countries. <I>Bad Faith</I> is the first book in a series to feature Sister Agatha. The authors live in Corrales, New Mexico.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?65c936d2